import React, { useState } from 'react'
import { Layout } from 'layouts/default'
import s from '../home/home.module.scss'
import dynamic from 'next/dynamic'

import { AppearTitle } from '../../components/appear-title'
import { Timeline } from '../../components/timeline'

// Custom checkbox component
const CustomCheckbox = ({ checked, label }) => {
  return (
    <li className="list-item" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
      <div
        style={{
          width: '20px',
          height: '20px',
          border: `2px solid ${checked ? '#0097fe' : '#ccc'}`,
          borderRadius: '4px',
          backgroundColor: checked ? '#0097fe' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease',
          position: 'relative',
          flexShrink: 0
        }}
      >
        {checked && (
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20,6 9,17 4,12"></polyline>
          </svg>
        )}
      </div>
      <span style={{ 
        color: checked ? '#0097fe' : 'inherit',
        transition: 'all 0.2s ease'
      }}>
        {label}
      </span>
    </li>
  )
}

const timelineData = [
  {
    title: "Phase 1",
    content: (
      <div>
        <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '16px', fontStretch: 'expanded' }}>
          Foundation and Setup
        </h3>
        <p style={{ marginBottom: '20px', fontSize: '18px' }}>
          Establishing the core infrastructure, team, and initial market presence for XENO's revolutionary 
          robotics ecosystem. This phase focuses on building solid foundations for scalable growth.
        </p>
        <ul className="animated-list" style={{ listStyle: 'none', padding: 0 }}>
          <CustomCheckbox 
            checked={true} 
            label="Core research and technical architecture planning" 
          />
          <CustomCheckbox 
            checked={true} 
            label="XENO company formation in Dubai" 
          />
          <CustomCheckbox 
            checked={true} 
            label="Whitepaper publishing and initial branding" 
          />
          <CustomCheckbox 
            checked={true} 
            label="Recruitment and team structuring" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Warehouse and fulfillment unit setup in Dubai" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Technical sourcing partnerships (manufacturing & logistics)" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Operational backend design and deployment" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Token creation and liquidity pool lock" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Initial token listing and DEX onboarding" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Marketing campaign rollout" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Launch of XENO Shop MVP and product inventory" 
          />
        </ul>
      </div>
    ),
  },
  {
    title: "Phase 2",
    content: (
      <div>
        <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '16px', fontStretch: 'expanded' }}>
          Ecosystem Rollout
        </h3>
        <p style={{ marginBottom: '20px', fontSize: '18px' }}>
          Launching key ecosystem components including rental models, gift card utilities, and DAO governance. 
          This phase establishes XENO's unique market position in robotics-as-a-service.
        </p>
        <ul className="animated-list" style={{ listStyle: 'none', padding: 0 }}>
          <CustomCheckbox 
            checked={true} 
            label="Launch of Robots on Rent (ROR) rental model" 
          />
          <CustomCheckbox 
            checked={true} 
            label="Launch of XENO Gift Card utility program" 
          />
          <CustomCheckbox 
            checked={true} 
            label="Expansion of product inventory in XENO Shop" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Integration of stablecoin payments alongside XENO token" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Development of NFT-based receipts and warranties" 
          />
          <CustomCheckbox 
            checked={false} 
            label="DAO voting system live for product prototypes" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Order management system enhancements" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Initial pilot deployments with commercial clients" 
          />
        </ul>
      </div>
    ),
  },
  {
    title: "Phase 3",
    content: (
      <div>
        <h3 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '16px', fontStretch: 'expanded' }}>
          Ecosystem Scaling
        </h3>
        <p style={{ marginBottom: '20px', fontSize: '18px' }}>
          Expanding into smart devices, global manufacturing, and institutional markets. 
          This phase transforms XENO from startup to established industry player with global reach.
        </p>
        <ul className="animated-list" style={{ listStyle: 'none', padding: 0 }}>
          <CustomCheckbox 
            checked={false} 
            label="Launch of smart devices including crypto-alert speaker" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Cross-border shipping and fulfillment capabilities" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Expansion to institutional-grade robotics deployments" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Global manufacturing scale-up (China and UAE)" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Real-time analytics dashboard for robot activity and sales" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Token staking platform for DAO and yield integration" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Launch of mobile app with live tracking and support" 
          />
        </ul>
      </div>
    ),
  },
  {
    title: "Phase 4",
    content: (
      <div>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', fontStretch: 'expanded' }}>
          Maturity and Decentralization
        </h3>
        <p style={{ marginBottom: '20px', fontSize: '18px' }}>
          Achieving full decentralization with DAO governance, third-party integrations, and global expansion. 
          XENO becomes a self-sustaining ecosystem powering the future of robotics commerce.
        </p>
        <ul className="animated-list" style={{ listStyle: 'none', padding: 0 }}>
          <CustomCheckbox 
            checked={false} 
            label="DAO-based revenue distribution fully implemented" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Third-party robotic listing system through XENO protocol" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Launch of enterprise dashboard for business users" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Hardware SDK release for developer community" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Regional expansion across Europe and Asia" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Onboarding of Web3 and corporate partners" 
          />
          <CustomCheckbox 
            checked={false} 
            label="Legal, compliance, and audit frameworks automated" 
          />
        </ul>
      </div>
    ),
  },
];

export default function TimelinePage() {

  const [theme] = useState('light')

  const WebGL = dynamic(
    () => import('components/webgl').then(({ WebGL }) => WebGL),
    { ssr: false }
  )

  return (
    <Layout
      theme={theme}
      seo={{
        title: 'Xeno Robotics',
        description:
          'Xeno Robotics is a pioneering engineering firm fusing state-of-the-art robotics with blockchain-driven intelligence to deliver autonomous systems that adapt, learn, and collaborate in diverse environments.',
      }}
      className={s.home}
    >
      <div className={s.canvas}>
        <WebGL />
      </div>

      <div style={{ height: '10vh' }}></div>

      <p
        className="h2"
        style={{ color: '#000', textAlign: 'center', marginBottom: '20px' }}
      >
        <AppearTitle>ROADMAP</AppearTitle>
      </p>

      <div style={{ height: '10vh' }}></div>

      <Timeline
        data={timelineData}
        theme="light" // or "dark"
      />
    </Layout>
  )
}
